module.exports = __webpack_public_path__ + "img/30.a3b7f752.png";